import rootStore from '@/store';
import { reportingService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default class ReportingCallLogsGridService {
  constructor() {
    this.gridCallback = () => [];
  }

  validateCurrentSettings() {
    return !!rootStore.getters['reporting/activeCallLogTranslatedTimeZoneId'];
  }

  getRows({ request, successCallback, failCallback, parentNode }) {
    // Notes
    // - Call logs API should return all columns values by default
    // - There will be no row group columns or value columns
    if (!this.validateCurrentSettings()) {
      return successCallback([], 0);
    }
    
    const { apiRequestData } = this.getApiRequestData(request, parentNode.columnApi);

    return reportingService.getCallLogs(rootStore.state.currentAccountId, apiRequestData).then(({ callLogs, totalCount }) => {
      successCallback(callLogs, totalCount);
      this.gridCallback(callLogs, totalCount);
    }).catch(failCallback);
  }

  setGridCallback(callback) {
    this.gridCallback = callback;
  }

  getApiRequestData(request, gridColumnApi) {
    const { reportStart, reportEnd } = reportingService.getReportingDateRange(
      rootStore.getters['reporting/activeCallLogTimeRange'],
      rootStore.getters['reporting/activeCallLogTranslatedTimeZoneId']
    );

    const filters = [
      ...reportingService.getFilterFromFilterCriteria(rootStore.getters['reporting/activeCallLogFilterCriteria'])
    ];

    const valueColumns = gridColumnApi.getAllColumns()
      .filter(c => c.colId !== 'action'
        && (c.userProvidedColDef.ringbaGroupName !== 'Tags'
        || (c.userProvidedColDef.ringbaGroupName === 'Tags' && c.visible)
        ))
      .map(c => {
        return {
          column: c.colId
        };
      });

    // The recordingKey report column carries the id the recording tempUrl endpoint
    // expects, so the player always requests it — gated on the backend actually
    // serving its definition for this role (same filter the callLogColumns getter
    // applies to every other column), because requesting a column the backend does
    // not define fails the whole query (and deduped: capable backends already
    // contribute it through the grid's own columns).
    const role = rootStore.getters['reporting/role'];
    const apiRole = role === 'publisher' ? 'affiliate' : role;
    const hasRecordingKeyColumn = rootStore.state.reporting.callLog.colDefs
      ?.some(def => def.id === 'recordingKey' && def.roles?.includes(apiRole));

    if (hasRecordingKeyColumn && !valueColumns.some(c => c.column === 'recordingKey')) {
      valueColumns.push({ column: 'recordingKey' });
    }

    return {
      apiRequestData: {
        reportStart,
        reportEnd,
        orderByColumns: request.sortModel.map(sort => (
          { column: sort.colId, direction: sort.sort }
        )),
        filters,
        valueColumns,
        formatTimespans: true,
        formatPercentages: true,
        formatDateTime: true,
        formatTimeZone: rootStore.getters['reporting/activeCallLogTranslatedTimeZoneId'],
        size: request.endRow - request.startRow,
        offset: request.startRow,
        viewAsPubId: rootStore.getters['reporting/activeCallLogViewAsPubId'],
        viewAsBuyerId: rootStore.getters['reporting/activeCallLogViewAsBuyerId'],
        viewAsManagerId: rootStore.getters['reporting/activeCallLogViewAsManagerId'],
      },
    };
  }

}